import { AddressContent } from "./addressContent";

export const FooterContent = {
  headingTop: "Yum",
  headingBottom: "Canal",
  navigation: [
    {
      label: "Menu",
      path: "/menu",
    },
    // {
    //   label: "Order Online",
    //   path: "/order",
    // },
    {
      label: "About",
      path: "/about",
    },
  ],
  timingSectionHeading: "OPENING HOURS",
  days1: "All Days",
  timeSlot1: "12pm - 11am",
  // days2: "Saturday & Sunday",
  // timeSlot2: "10am - 7pm",
  addressHeading: "WHERE WE ARE",
  addressText: AddressContent.addressText,
  contactHeading: "CONTACT",
  contactNumbers: [
    "+91 7814244386",
    "+91 7009037495",
  ],
  extraLinks: [
    // {
    //   label: "Terms & Conditions",
    //   path: "/",
    // },
    // {
    //   label: "Refund Policy",
    //   path: "/",
    // },
    // {
    //   label: "Privacy Policy",
    //   path: "/",
    // },
  ],
  copyrightText: "2025 copyrights. Yum Canal.",
};
